import React, { Component } from 'react';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement
} from 'react-stripe-elements';

import Select from 'react-select'
import stateNamesOptions from '../../utils/data/stateNames.json'

// Components
import ChecklistFormInput from '../Global/Forms/ChecklistFormInput';

class CreditCardForm extends Component {

  state = {
    input: {
      nameOnCard: {
        value: "",
        empty: true,
        hasError: false
      },
      cardNumber: {
        empty: true,
        hasError: false
      },
      cardExpirationDate: {
        empty: true,
        hasError: false
      },
      cvc: {
        empty: true,
        hasError: false
      },
      cardStreet: {
        value: "",
        empty: true,
        hasError: false
      },
      cardCity: {
        value: "",
        empty: true,
        hasError: false
      },
      cardState: {
        value: "",
        empty: true,
        hasError: false
      },
      cardZip: {
        value: "",
        empty: true,
        hasError: false
      },
      couponCode: {
        value: "",
        empty: true,
        hasError: false
      }
    },
    terms: [{
      value: false,
      label: (
        <span>
          Upon proceeding with Payment for the Locker Linked LLC service you have read and agree with the <a href="https://lockerlinked.com/terms-of-use/" target="_blank" className="text-link" rel="noopener noreferrer">Locker Linked Terms of Service,</a> and you are representing that you are the Parent or legal Guardian of the student-athlete using this service.
        </span>
      )
    }],
    termsHasError: false,
    stateSelectOptions: []
  }

  componentDidMount() {
    this.setState(state => ({
      stateSelectOptions: stateNamesOptions
    }))
  }

  componentWillReceiveProps(nextProps) {
    const { coupon } = nextProps
    if (coupon && 'valid' in coupon) {
      this.setState(state => ({
        input: {
          ...state.input,
          couponCode: {
            ...state.input.couponCode,
            hasError: !coupon.valid
          }
        }
      }))
    }
  }

  handleInputChange(newPartialInput) {
    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        ...newPartialInput,
      }
    }))
  }

  handleCardZipChange = (stripeEvent, cardDetail) => {
      this.handleInputChange(cardDetail);

      if (stripeEvent.value.length === 5 && !stripeEvent.error) {
        this.props.getTaxRate(stripeEvent.value)
    }
  }

  handleTermsCheckboxChange = (name, checkboxPosition) => {
    let updatedTermsCheckbox = [...this.state.terms]

    updatedTermsCheckbox[0].value = !updatedTermsCheckbox[0].value;

    this.setState(state => ({
      terms: updatedTermsCheckbox,
      termsHasError: false
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.validateForm()) {
      this.createStripeTokenAndTriggerSubmit(event)
    } else {
      this.setFormErrorState();
    }
  }

  createStripeTokenAndTriggerSubmit(event) {
    // Unfocus Stripe Input Fields
    // This is a known fix for an issue with Mobile Safari
    setTimeout(() => {
      this._element.focus();
      this._element.blur();
    }, 20);

    this.props.stripe.createToken({name: this.state.input.nameOnCard.value, address_zip: this.state.input.cardZip.value, address_country: 'US'})
    .then((response) => {
      this.props.handleFormSubmit(response, {street: this.state.input.cardStreet.value, city: this.state.input.cardCity.value, state: this.state.input.cardState.value, zip: this.state.input.cardZip.value});
    })
  }

  validateForm = () => {
    let newInputState = {...this.state.input};
    let { terms } = this.state;
    let errorsArePresent = false;

    Object.entries(newInputState).forEach(([key, value]) => {
      if (key === 'couponCode') {
        return
      }
      if (value.empty || value.error){
        errorsArePresent = true
      }
    });

    if (!terms[0].value) {
      errorsArePresent = true;
    }

    if (errorsArePresent) {
      return false;
    } else {
      return true;
    }
  }

  handleCoupon = () => {
    if (!this.state.input.couponCode.empty) {
      this.props.validateCoupon(this.state.input.couponCode.value)
    }
  }

  setFormErrorState = () => {
    let newInputState = {...this.state.input};
    let errorsArePresent = false;
    let termsHasError = true;
    let { terms } = this.state;

    Object.entries(newInputState).forEach(([key, value]) => {
      if (value.empty || value.error){
        newInputState[key].hasError = true;
        errorsArePresent = true
      }
    });

    if (!terms[0].value) {
      errorsArePresent = true;
    } else {
      termsHasError = false
    }

    if (errorsArePresent) {
      this.setState(state => ({
        ...state,
        input: newInputState,
        termsHasError: termsHasError
      }))
    }
  }

  renderErrorMessage(input) {
    let message = '';
    if (input === 'nameOnCard') {
      message = 'Please enter the name on your card';
    } else if (input === 'cardNumber') {
      message = 'Please enter a valid card number';
    } else if (input === 'cardExpirationDate') {
      message = 'Please enter a valid expiration date';
    } else if (input === 'cvc') {
      message = "Please enter your card's CVC";
    } else if (input === 'cardStreet') {
      message = "Please enter your card's street address";
    } else if (input === 'cardCity') {
      message = "Please enter your card's city";
    } else if (input === 'cardState') {
      message = "Please select your card's state";
    } else if (input === 'cardZip') {
      message = "Please enter your card's zip code";
    } else if (input === 'couponCode') {
      message = "Invalid Coupon Code";
    }

    return (
      <div className="input-error-message">
        {message}
      </div>
    )
  }

  generateSubmitText = () => {
    if (this.props.submitText) {
      return this.props.submitText
    } else {
      return "Submit"
    }
  }

  render() {
    let { input, terms, termsHasError } = this.state;
    const { status, paymentNote } = this.props;

    const style = {
      base: {
        'fontSize': '16px',
        'color': '#252525',
        'fontFamily': 'HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica',
        '::placeholder': {
          'color': '#9B9B9B',
        },
      },
      invalid: {
        'color': '#fb5c82',
        ':focus': {
          'color': '#252525',
        },
      },
    };

    const inlineInput = {
      'width' : '70%'
    }

    return (
      <form
        className="credit-card-form"
        onSubmit={(event) => this.handleSubmit(event)}
      >
        <div className="admin-form-row">
          <div
            className={`input-container${input.nameOnCard.hasError ? ' error' : ''}`}
          >
            <label htmlFor="nameOnCard">
              Name on Card
            </label>
            <input type="text"
              id="nameOnCard"
              placeholder="Enter Name"
              value={input.nameOnCard.value}
              onChange={event => this.handleInputChange(
               {nameOnCard: {value: event.target.value, hasError: false, empty: event.target.value.length > 0 ? false : true}}
              )}
            />
            {input.nameOnCard.hasError ? this.renderErrorMessage('nameOnCard') : null}
          </div>
        </div>
        <div className="admin-form-row">
          <div
            className={`input-container ${input.cardStreet.hasError ? ' error' : ''}`}
          >
            <label htmlFor="streetOnCard">
              Street Address
            </label>
            <input type="text"
              id="streetOnCard"
              placeholder="123 Main Street"
              value={input.cardStreet.value}
              onChange={event => this.handleInputChange(
                {cardStreet: {value: event.target.value, hasError: false, empty: event.target.value.length > 0 ? false : true}}
              )}
            />
            {input.cardStreet.hasError ? this.renderErrorMessage('cardStreet') : null}
          </div>
        </div>
        <div className="admin-form-row">
          <div
            className={`input-container ${input.cardCity.hasError ? ' error' : ''}`}
          >
            <label htmlFor="cityOnCard">
              City
            </label>
            <input type="text"
              id="cityOnCard"
              placeholder="Anytown"
              value={input.cardCity.value}
              onChange={event => this.handleInputChange(
                {cardCity: {value: event.target.value, hasError: false, empty: event.target.value.length > 0 ? false : true}}
              )}
            />
            {input.cardCity.hasError ? this.renderErrorMessage('cardCity') : null}
          </div>
        </div>
        <div className="admin-form-row">
          <div
            className={`input-container half${input.cardState.hasError ? ' error' : ''}`}
          >
            <label htmlFor="stateOnCard">
              State
            </label>
            <Select
              name='stateOnCard'
              value={input.cardState.value}
              placeholder="--"
              options={this.state.stateSelectOptions}
              onChange={event => this.handleInputChange(
                {cardState: {value: event ? event.value : '', hasError: false, empty: event ? false : true}}
              )}
              clearable={false}
            />
            {input.cardState.hasError ? this.renderErrorMessage('cardState') : null}
          </div>
          <div
            className={`input-container half${input.cardZip.hasError ? ' error' : ''}`}
          >
            <label className="stripe-label">
              Zip Code
            </label>
            <PostalCodeElement
              style={style}
              placeholder="12345"
              onChange={event => this.handleCardZipChange(event,
                {cardZip: {value: event.value, empty: event.empty, hasError: event.error}}
              )}
              elementRef={element => this._element = element}
            />
            {input.cardZip.hasError ? this.renderErrorMessage('cardZip') : null}
          </div>
        </div>
        <div className="admin-form-row">
          <div
            className={`input-container${input.cardNumber.hasError ? ' error' : ''}`}
          >
            <label className="stripe-label">
              Credit Card Number
            </label>
            <CardNumberElement
              style={style}
              placeholder="1234 5678 1234 5678"
              onChange={event => this.handleInputChange(
                {cardNumber: {empty: event.empty, hasError: event.error}}
              )}
              elementRef={element => this._element = element}
            />
            {input.cardNumber.hasError ? this.renderErrorMessage('cardNumber') : null}
          </div>
        </div>
        <div className="admin-form-row full-box">
          <div
            className={`input-container half${input.cardExpirationDate.hasError ? ' error' : ''}`}
          >
            <label className="stripe-label">
              Expiration Date
            </label>
            <CardExpiryElement
              style={style}
              placeholder="01/20"
              onChange={event => this.handleInputChange(
                {cardExpirationDate: {empty: event.empty, hasError: event.error}}
              )}
              elementRef={element => this._element = element}
            />
            {input.cardExpirationDate.hasError ? this.renderErrorMessage('cardExpirationDate') : null}
          </div>
          <div
            className={`input-container half${input.cvc.hasError ? ' error' : ''}`}
          >
            <label className="stripe-label">
              CVV
            </label>
            <CardCVCElement
              style={style}
              placeholder="***"
              onChange={event => this.handleInputChange(
                {cvc: {empty: event.empty, hasError: event.error}}
              )}
              elementRef={element => this._element = element}
            />
            {input.cvc.hasError ? this.renderErrorMessage('cvc') : null}
          </div>
        </div>
        <hr />
        { this.props.coupon && !this.props.hideCouponField &&
          <div className="admin-form-row">
            <div
              className={`input-container${input.couponCode.hasError ? ' error' : ''}`}
            >
              <label htmlFor="couponCode">
                Coupon Code
              </label>
              <input type="text"
                id="couponCode"
                style={inlineInput}
                placeholder="123XYZ"
                value={input.couponCode.value}
                onChange={event => this.handleInputChange(
                  {
                    couponCode: {
                      value: event.target.value,
                      hasError: false,
                      empty: event.target.value.length > 0 ? false : true
                    }
                  }
                )}
              />
              <a
                className='cta-inline'
                onClick={this.handleCoupon}
              >
                Apply
              </a>
              {input.couponCode.hasError ? this.renderErrorMessage('couponCode') : null}
            </div>
          </div>
        }
        {paymentNote}
        <ChecklistFormInput
          label="Terms of Service"
          name="terms"
          selectedOption={terms}
          showError={termsHasError}
          errorMessage={termsHasError ? 'You must agree to Locker Linked terms of service to continue' : ''}
          onChange={this.handleTermsCheckboxChange}
          options={terms}
        />
        {
          status !== 'submitting' &&
          <input
            id="submit-form"
            type="submit"
            value={this.generateSubmitText()}
          />
        }
        {
          status === 'submitting' &&
          <div className="spinner"></div>
        }
      </form>
    );
  }
}

export default injectStripe(CreditCardForm);



// WEBPACK FOOTER //
// ./src/components/Forms/CreditCardForm.js